import { Node, mergeAttributes } from '@tiptap/core';

export type TemplateVariableLabelFn = (name: string) => string;

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    templateVariable: {
      insertTemplateVariable: (name: string) => ReturnType;
    };
  }
}

export const TemplateVariable = Node.create<{
  getLabel: TemplateVariableLabelFn;
}>({
  name: 'templateVariable',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addOptions() {
    return {
      getLabel: (name: string) => name,
    };
  },

  addAttributes() {
    return {
      name: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-template-var'),
        renderHTML: (attributes) =>
          attributes.name ? { 'data-template-var': attributes.name } : {},
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-template-var]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    const name = String(node.attrs.name ?? '');
    return [
      'span',
      mergeAttributes(HTMLAttributes, { class: 'rte-template-var' }),
      this.options.getLabel(name) || name,
    ];
  },

  renderText({ node }) {
    const name = String(node.attrs.name ?? '');
    return this.options.getLabel(name) || name;
  },

  addCommands() {
    return {
      insertTemplateVariable:
        (name: string) =>
        ({ chain }) =>
          chain()
            .focus()
            .insertContent({ type: this.name, attrs: { name } })
            .run(),
    };
  },
});
